import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useContent } from "../i18n/LanguageContext";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const cookie = useContent().cookie;
  const onPortal = useLocation().pathname === "/portal";

  useEffect(() => {
    const consent = localStorage.getItem("barlow_cookie");
    if (!consent) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (val) => {
    localStorage.setItem("barlow_cookie", val);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className={`fixed bottom-0 right-0 z-[60] bg-white border-t border-[#e7e2d8] shadow-[0_-8px_30px_-15px_rgba(0,0,0,0.15)] ${onPortal ? "left-0 lg:left-64" : "left-0"}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex flex-col md:flex-row items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={22} className="text-[#b08d57] shrink-0 mt-0.5" />
          <p className="text-sm text-[#5c6577]">
            {cookie.text} <a href="#top" className="text-[#b08d57] underline">{cookie.more}</a>
          </p>
        </div>
        <div className="flex gap-3 shrink-0">
          <button onClick={() => decide("necessary")} className="btn-outline-navy rounded-md px-5 py-2.5 text-sm font-medium">
            {cookie.necessary}
          </button>
          <button onClick={() => decide("all")} className="btn-gold rounded-md px-5 py-2.5 text-sm font-medium">
            {cookie.all}
          </button>
        </div>
      </div>
    </div>
  );
}
